import type { AiTableCell } from '@apis/aiAgent';

export interface IRowGroup {
  /** The grouped column's value for every row in the group. */
  value: AiTableCell;
  rows: Record<string, AiTableCell>[];
}

/**
 * Rows grouped by one column's value, the groups in the order their first row
 * arrives. The server already orders a breakdown's rows (floors in building
 * order, trades by weight), so first appearance keeps that order, and a sort
 * the reader picks applies within each group.
 */
export function groupRows(rows: Record<string, AiTableCell>[], columnId: string): IRowGroup[] {
  const groups = new Map<string, IRowGroup>();
  for (const row of rows) {
    const key = String(row[columnId] ?? '');
    const group = groups.get(key);
    if (group === undefined) groups.set(key, { value: row[columnId], rows: [row] });
    else group.rows.push(row);
  }
  return [...groups.values()];
}
